<app-main-video></app-main-video>
<app-background-transitions [mouseMoved]="c.mouseMoved"></app-background-transitions>
<app-small-video></app-small-video>
<app-control-bar #c></app-control-bar>
